<template>
    <div class="page">
        <el-form ref="form" :model="attributeWholeList" label-width="70px">
            <el-tabs type="border-card">
                <el-tab-pane label="基本信息">
                    <information-edit
                        ref="form1"
                    ></information-edit>
                </el-tab-pane>
                <el-tab-pane label="商品相册">
                    <el-form-item label="商品相册" prop="productAlbum">
                        <el-upload
                            :headers="header"
                            class="uploadAlbum"
                            :action="action"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleSuccess"
                            :before-upload="beforeAvatarUpload"
                            list-type="picture"
                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                            :limit="10"
                            :disabled="stateDisabled"
                        >
                            <el-button size="small" :disabled="stateDisabled" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="商品视频" prop="productAlbum">
                        <el-upload
                            class="uploadAlbum"
                            action=""
                            :disabled="stateDisabled"
                            :file-list="videoFileList"
                            :before-upload="handleBeforeUpload"
                            :on-remove="handleVodRemove"
                            :http-request="uploadAvatar"
                            :on-success="onSucc"
                            list-type="picture"
                            :limit="1"
                        >
                            <el-button size="small" type="primary" :disabled="stateDisabled">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过50mb</div>
                        </el-upload>
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="商品描述">
                    <el-form-item label="商品简介" prop="saleStatement">
                        <el-input
                            type="textarea"
                            style="width: 800px"
                            :disabled="stateDisabled"
                            size="small"
                            :rows="3"
                            v-model="attributeWholeList.saleStatement"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="商品详情" prop="productContent">
                        <WangEditor ref="contentEditor" :disabled="stateDisabled" v-model="attributeWholeList.productContent" />
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="fourthly" style="padding-left: 30px" label="规格属性">
                    <Attribute ref="attr1"></Attribute>
                    <Attribute2 ref="attr2"></Attribute2>
                    <Attribute3 ref="attr3"></Attribute3>
                    <el-form :model="aliasObj" :inline="true" label-width="70px">
                        <el-form-item label="规格别名" prop="alias1">
                            <el-input style="width: 130px" placeholder="请填写规格别名" v-model="aliasObj.alias1"></el-input>
                        </el-form-item>
                        <el-form-item label="加料别名" prop="alias2">
                            <el-input style="width: 130px" placeholder="请填写加料别名" v-model="aliasObj.alias2"></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <!-- <el-form-item style="text-align: right; margin-bottom: 0">
                    <el-button v-if="shopProductState != 'check'" type="primary" @click="submitForm">修改</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </el-form-item> -->
            </el-tabs>
        </el-form>
    </div>
</template>

<script>
import InformationEdit from '../../components/restaurant/InformationEdit.vue';
import WangEditor from '@/components/common/wangeditor';
import { get, post, postJson, upload } from '@/utils/request.js';
import eventBus from '../../api/eventBus';
import { UPLOAD_API,UPLOAD_PATH } from '@/utils/constant.js';
import Attribute2 from '@/components/restaurant/Attribute2.vue';
import Attribute3 from '@/components/restaurant/Attribute3.vue';
import Attribute from '@/components/restaurant/Attribute.vue';

export default {
    components: {
        Attribute, Attribute3, Attribute2,
        InformationEdit,
        WangEditor
    },
    props: {
        shopProduct: {
            type: Object,
            default: {}
        },
        shopProductState: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            attributeWholeList: {
                productContent: '',
                saleStatement: '',
                productAlbum: '',
                productVideo: '',
            },
            aliasObj:{
                alias1: '',
                alias2: ''
            },
            albumList: '',
            isScoreList: [
                {
                    value: 0,
                    label: '否'
                },
                {
                    value: 1,
                    label: '是'
                }
            ],
            header: {
                token: localStorage.getItem('token')
            },
            fileList: [],
            videoFileList: [],

            temporaryList: [],
            stateDisabled: false,
            action: UPLOAD_API + UPLOAD_PATH,
            fileType: ['mp4'],
            // 上传文件大小限制(MB)
            fileSize: '50'
        };
    },
    created() {},
    watch: {
        // 监听分类id
        shopProduct: {
            handler(newVal, oldVal) {
                if (Object.keys(newVal).length != 0) {
                    console.log(newVal,"在这里呢")

                    this.aliasObj.alias1 = newVal.specName;
                    this.aliasObj.alias2 = newVal.attachName;

                    if(this.shopProductState == 'check'){
                        this.$refs.attr1.setStatus()
                        this.$refs.attr2.setStatus()
                        this.$refs.attr3.setStatus()
                    }
                    if(newVal.specList && newVal.specList.length > 0){
                        this.$refs.attr1.init(newVal.specList)
                    }

                    for (let item of newVal.attributeList) {
                        if(item.itemList && item.itemList.length < 20){
                            for (let i = 0; i < 20 - item.itemList.length; i++) {
                                item.itemList.push({
                                    itemName: ''
                                })
                            }
                        }
                    }

                    if(newVal.attributeList && newVal.attributeList.length > 0){
                        this.$refs.attr2.init(newVal.attributeList)
                    }

                    if(newVal.attachList && newVal.attachList.length > 0){
                        this.$refs.attr3.init(newVal.attachList)
                    }

                    this.attributeWholeList = { ...this.attributeWholeList, ...newVal };
                    //视频不为空
                    this.videoFileList = [];
                    if (this.attributeWholeList.productVideo) {
                        this.videoFileList.push({
                            name: this.attributeWholeList.productVideo,
                            url: this.attributeWholeList.productVideo
                        });
                    }

                    console.log(this.videoFileList);
                    this.$refs.contentEditor.init(this.attributeWholeList.productContent);
                    console.log(this.attributeWholeList);
                    eventBus.$emit('shopProduct', this.attributeWholeList, this.shopProductState);
                    this.fileList = [];
                    if (this.attributeWholeList.productAlbum) {
                        let str = this.attributeWholeList.productAlbum;
                        var list = str.split('|');

                        this.fileList = list.map((item) => {
                            return {
                                name: item,
                                url: item
                            };
                        });
                        this.temporaryList = [];
                        for (let item of list) {
                            this.temporaryList.push(item);
                        }
                        this.albumList = '';
                        this.albumList = this.temporaryList.join('|');
                    }
                }
            },
            immediate: true,
            deep: true
        },
        shopProductState: {
            handler(newVal, oldVal) {
                if (newVal == 'check') {
                    this.stateDisabled = true;
                } else {
                    this.stateDisabled = false;
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        // change() {
        //     console.log(this.attributeWholeList.productType);
        // },
        // 删除图片
        handleRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (!file.response) {
                    if (file.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                } else {
                    if (file.response.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                }
            }
            this.albumList = this.temporaryList.join('|');
        },
        //上传成功
        handleSuccess(response, file, fileList) {
            console.log(this.temporaryList);
            console.log(file);
            console.log(fileList);
            // this.temporaryList = [];
            this.temporaryList.push(file.response.url);
            console.log(this.temporaryList);
            this.albumList = this.temporaryList.join('|');

            console.log(this.albumList);
        },
        //上传图片限制
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        aa() {
            console.log(222222);
        },

        // 生成唯一Id
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },

        // 关闭
        closeDialog() {
            this.$refs.attr1.specList = [];
            this.$refs.attr2.specList = [];
            this.$refs.attr3.specList = [];
            this.$refs.attr1.status = false
            this.$refs.attr2.status = false
            this.$refs.attr3.status = false
        },
        //上传视频
        uploadAvatar(params) {
            const file = params.file;
            console.log(file);
            // let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            // if (!types.includes(file.type)) {
            //     this.$message.error('图片类型错误!');
            // }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.attributeWholeList.productVideo = res.url;
                    console.log(this.attributeWholeList.productVideo);
                    console.log(this.videoFileList);
                }
            });
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            console.log(this.attributeWholeList.productVideo);
            if (this.attributeWholeList.productVideo != '' && this.attributeWholeList.productVideo != null) {
                this.$message({
                    message: '最多上传一个视频',
                    type: 'info',
                    duration: 2000
                });
                return false;
            }
            // 校检文件类型
            if (this.fileType && file) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk && file) {
                    this.$message({
                        message: `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }
            // 校检文件大小;
            if (this.fileSize && file) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message({
                        message: `上传文件大小不能超过 ${this.fileSize} MB!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }

            return true;
        },
        handleVodRemove(file, fileList) {
            // console.log(file);
            // console.log(fileList);
            if (fileList.length == 0) {
                this.attributeWholeList.productVideo = '';
                this.videoFileList = [];
            }
        },

        // 提交修改
        submitForm() {
            // return;
            if (!this.$refs.form1.validateForm()) {
                this.$message({
                    message: '基本信息页没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }

            this.attributeWholeList.productAlbum = this.albumList;

            let product = this.$refs.form1.shopProduct;

            delete product.productContent;
            delete product.saleStatement;
            delete product.productAlbum;
            delete product.isScore;
            delete product.scoreType;

            // 商品不为积分商品时清楚所需积分
            if(product.productType!=2){
                product.productScore = 0
            }

            let specList = this.$refs.attr1.specList;
            let attributeList = this.$refs.attr2.specList;
            let attachList = this.$refs.attr3.specList;

            let shopProduct = {
                ...this.attributeWholeList,
                ...product,
                specName: this.aliasObj.alias1,
                attachName: this.aliasObj.alias2,
                productVideo: this.attributeWholeList.productVideo,
                specList: specList,
                attributeList: attributeList,
                attachList: attachList
            };
            console.log('shopProduct',shopProduct);
            postJson('/restaurant/product/edit', { ...shopProduct }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.$emit('closeDialog', true);
                    this.closeDialog();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                    // this.$emit('closeDialog', true);
                }
            });
        },
        onSucc(response, file, fileList) {
            console.log(this.videoFileList);
        }
    }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//     width: 200px;
//     height: 200px;
// }
</style>
